export const issueSeparatorCode = 9;
